<template lang="html">
  <div>
    <v-form ref="creationApprovalLevelForm">
      <v-data-iterator
        :items="leaveTypes"
        :hide-default-footer="true"
        disable-pagination
        item-key="id"
      >
        <template>
          <v-row>
            <v-col
              v-for="(leaveType,index) in leaveTypes"
              :key="index"
              cols="12"
              md="6"
            >
              <v-card class="mx-6">
                <v-card-title style="padding-top:0;padding-bottom:0;margin:0">
                  <span class="title v-label theme--light pt-3">Leave Type: {{ leaveType.name }}</span>
                </v-card-title>

                <v-divider />
                <v-list
                  dense
                >
                  <v-list-item
                    class=""
                  >
                    <v-list-item-content
                      class="py-0"
                    >
                      Final Approver:
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-checkbox 
                        v-model="leaveType.is_final_approver"
                      />
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>

      <v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="goPrevious"
          >
            Go back
          </v-btn>
          <v-btn
            color="success"          
            @click="submitForm"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-form>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        loading: false,
        progressing: false,
        leaveTypes: [], 
      }
    },
    created () {
      this.loading = true
      this.loadData()
    },
    methods: {
      loadData () {
        this.$http.all([
          this.$api.leaveTypes().list(),
        ])
          .then(this.$http.spread((leaveTypes) => {
            this.leaveTypes = leaveTypes.data.map((leaveType) => {
              return {
                id: leaveType.id,
                name: leaveType.name,
                is_final_approver: 0,
              }
            })

            this.loading = false
          }))
      },
      submitForm () {
        this.$emit('submit-form')
      },
      goPrevious () {
        this.$emit('previous-step')
      },
      getFormData () {
        return this.leaveTypes.map((leaveType) => {
          return {
            id: leaveType.id,
            is_final_approver: leaveType.is_final_approver === true ? 1 : 0,
          }
        })
      },
      
    },
  }
</script>

<style lang='css' scoped>
  ::v-deep .centered-input input {
    text-align: center
  }
</style>
